// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getUnpreparedAudit} from '../../shared/repositories';

export const readUnpreparedAudit = accounts =>

    async dispatch => {

        const accountsArray = typeof accounts === 'string' ? [accounts] : accounts;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getUnpreparedAudit(accountsArray);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_PREPARE_AUDIT_AUDIT
            });

            dispatch({
                isAuditLoaded: true,
                type: actions.UPDATE_TCSM_PREPARE_AUDIT_IS_AUDIT_LOADED
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/get-unprepared-audit.js